module.exports = __webpack_public_path__ + "img/12a_asia.b9654477.png";